import React from 'react';
import './Privacy.css';

function Privacy() {
  return (
    <div className="privacy">
      <section className="privacy-header">
        <h1>Privacy Policy</h1>
        <p>Last Updated: {new Date().toLocaleDateString('en-US', { year: 'numeric', month: 'long', day: 'numeric' })}</p>
      </section>

      <section className="privacy-content">
        <div className="content-wrapper">
          <div className="privacy-section">
            <h2>Introduction</h2>
            <p>
              At 42 Pets ("we", "our", or "us"), we respect your privacy and are committed to 
              protecting your personal information. This Privacy Policy explains how we collect, 
              use, and safeguard information when you use our mobile applications, including 
              BartMenu, and visit our website.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Information We Collect</h2>
            
            <h3>Non-Personal Information</h3>
            <p>
              We collect non-personal information to improve our applications and provide a 
              better user experience. This includes:
            </p>
            <ul>
              <li>Device information (device model, operating system version)</li>
              <li>App usage statistics (features used, session duration)</li>
              <li>Crash reports and performance data</li>
              <li>Anonymous analytics data</li>
            </ul>

            <h3>Personal Information</h3>
            <p>
              We do not collect personally identifiable information such as your name, email 
              address, or contact details unless you explicitly provide them to us through 
              support requests or feedback forms. Support requests may also include comments,
              screenshots, or other information you choose to provide.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Use of Firebase Analytics</h2>
            <p>
              Our applications use Firebase Analytics, a service provided by Google LLC, 
              to collect and analyze usage data. Firebase Analytics helps us understand how 
              users interact with our apps, which features are most popular, and how we can 
              improve the user experience.
            </p>
            <p>
              The data collected by Firebase Analytics includes:
            </p>
            <ul>
              <li>App open and close events</li>
              <li>Screen views and navigation patterns</li>
              <li>In-app actions and feature usage</li>
              <li>Device and network information</li>
            </ul>
            <p>
              All data collected through Firebase Analytics is aggregated and anonymized. 
              We do not use this data to personally identify individual users.
            </p>
            <p>
              For more information about Firebase Analytics and how Google processes data, 
              please visit:{' '}
              <a href="https://firebase.google.com/support/privacy" target="_blank" rel="noopener noreferrer">
                https://firebase.google.com/support/privacy
              </a>
            </p>
          </div>

          <div className="privacy-section">
            <h2>How We Use Information</h2>
            <p>
              The non-personal information we collect is used to:
            </p>
            <ul>
              <li>Improve app performance and fix bugs</li>
              <li>Understand user preferences and behavior patterns</li>
              <li>Develop new features and enhance existing ones</li>
              <li>Ensure the security and stability of our applications</li>
              <li>Provide customer support when requested</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Data Storage and Security</h2>
            <p>
              Any data stored locally on your device remains under your control. We implement 
              industry-standard security measures to protect data transmitted to our servers 
              and third-party services. However, no method of transmission over the internet 
              is 100% secure, and we cannot guarantee absolute security.
            </p>
            <p>
              Support form submissions and optional screenshots are transmitted through Amazon
              Web Services and delivered to us by email. We use that information to respond to
              the request and diagnose the reported issue.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Third-Party Services</h2>
            <p>
              Our applications may contain links to third-party websites or services. We are 
              not responsible for the privacy practices of these third parties. We encourage 
              you to read the privacy policies of any third-party services you interact with.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Children's Privacy</h2>
            <p>
              Our applications are not directed to children under the age of 13. We do not 
              knowingly collect personal information from children under 13. If you believe 
              we have inadvertently collected such information, please contact us immediately.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Data Retention</h2>
            <p>
              We retain non-personal analytics data for as long as necessary to fulfill the 
              purposes outlined in this Privacy Policy. You can delete the app at any time 
              to stop all data collection from your device.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Your Rights</h2>
            <p>
              You have the right to:
            </p>
            <ul>
              <li>Stop data collection by uninstalling our applications</li>
              <li>Request information about the data we collect</li>
              <li>Request deletion of any personal information we may have</li>
              <li>Opt out of analytics by disabling analytics in device settings</li>
            </ul>
          </div>

          <div className="privacy-section">
            <h2>Changes to This Privacy Policy</h2>
            <p>
              We may update this Privacy Policy from time to time. We will notify users of 
              any material changes by posting the new Privacy Policy on this page and updating 
              the "Last Updated" date. We encourage you to review this Privacy Policy 
              periodically for any changes.
            </p>
          </div>

          <div className="privacy-section">
            <h2>Compliance</h2>
            <p>
              This Privacy Policy is designed to comply with:
            </p>
            <ul>
              <li>Apple App Store Guidelines</li>
              <li>California Consumer Privacy Act (CCPA)</li>
              <li>General Data Protection Regulation (GDPR) principles</li>
              <li>Other applicable U.S. and international privacy laws</li>
            </ul>
          </div>

          <div className="privacy-section contact-section">
            <h2>Contact Us</h2>
            <p>
              If you have any questions about this Privacy Policy or our data practices, 
              please contact us through the App Store or our support channels.
            </p>
          </div>
        </div>
      </section>
    </div>
  );
}

export default Privacy;
